module.exports = __webpack_public_path__ + "static/media/lista-atendimento.369e858c.gif";